<template>
  <teleport to="body">
    <div
      v-if="show"
      class="overlay"
      @click.self="$emit('close')"
    >
      <div class="modal">
        <div class="header">
          <h3 class="title">Export Options</h3>
          <button class="close-btn" @click="$emit('close')">
            &times;
          </button>
        </div>
        <div class="body">
          <p class="desc">
            Select which sections to include in the report:
          </p>
          <label class="checkbox">
            <input type="checkbox" v-model="sections.summary" />
            <span>Summary</span>
          </label>
          <label class="checkbox">
            <input type="checkbox" v-model="sections.byMedia" />
            <span>By Media</span>
          </label>
          <label class="checkbox">
            <input type="checkbox" v-model="sections.byPlayer" />
            <span>By Player</span>
          </label>
          <label class="checkbox">
            <input type="checkbox" v-model="sections.timeSeries" />
            <span>Time Series</span>
          </label>
        </div>
        <div class="footer">
          <button class="rpt-btn" @click="$emit('close')">
            Cancel
          </button>
          <button
            class="rpt-btn rpt-btn-primary"
            @click="$emit('export', { ...sections })"
            :disabled="!canExport"
          >
            Export
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts" setup>
import { reactive, computed } from 'vue'
import type { ExportSections } from '../composables/useReportExport'

defineProps<{
  show: boolean
}>()

defineEmits<{
  (e: 'close'): void
  (e: 'export', sections: ExportSections): void
}>()

const sections = reactive({
  summary: true,
  byMedia: true,
  byPlayer: true,
  timeSeries: true,
})

const canExport = computed(
  () => sections.summary || sections.byMedia || sections.byPlayer || sections.timeSeries
)
</script>

<style scoped>
@import '@/views/ReportsView/styles/reports-shared.css';

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  width: 400px;
  max-width: 90vw;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
}

.title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #9ca3af;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

.close-btn:hover {
  color: #374151;
}

.body {
  padding: 1.25rem;
}

.desc {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0 0 1rem;
}

.checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0;
  cursor: pointer;
  font-size: 0.9rem;
  color: #374151;
}

.checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #25294a;
  cursor: pointer;
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}
</style>
